import { requests, setToken } from '../helper/Agent';
const TOKEN_CAPTCHA = process.env.REACT_APP_CAPTCHA_SECRET;

export default class Auth {
  static signIn(data) {
    return requests.post('/sign-in', data);
  }

  static setToken(token) {
    setToken(token);
  }

  static signOut() {
    return requests.post('/sign-out');
  }

  static async restPassword(body) {
    const token = await window.grecaptcha.execute(TOKEN_CAPTCHA, { action: 'submit' });
    return requests.post(`/recover-password?token=${token}`, body);
  }
}
